var map = {
	"./de.json": "6ce2",
	"./el.json": "f184",
	"./en.json": "edd4",
	"./es.json": "a306",
	"./fr.json": "f693",
	"./it.json": "0825",
	"./jp.json": "9e97",
	"./kr.json": "c1af",
	"./nl.json": "a625",
	"./pt.json": "5d67",
	"./ru.json": "7704",
	"./zhcn.json": "f2ab",
	"./zhhk.json": "74fd",
	"./zhint.json": "110c",
	"./zhtw.json": "bb9b",
	"./zhus.json": "aa3f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "49f8";